export default __webpack_public_path__ + "static/bg_buniversity-df7bf9ed509f36421084db587431c435.jpg";